<template>
  <div id="navigate">
    <div class="menu">
      <div class="logo">
        <a alt="">
          <el-image class="logo-img" :src="logoImg">
            <div slot="placeholder" class="image-slot">
              Loading<span class="dot">...</span>
            </div>
          </el-image>
        </a>
      </div>
      <div class="tabbar">
        <el-menu
          :default-active="activeIndex"
          :router="true"
          class="menu-content"
          mode="horizontal"
        >
          <!-- @select="handleSelect" -->
          <el-menu-item index="/">
            <font-awesome-icon icon="fa-solid fa-house" />
            <span slot="title"> Home</span>
          </el-menu-item>
          <el-menu-item index="/eq_perdict">
            <font-awesome-icon icon="fa-solid fa-chart-line" />
            <span slot="title"> Earthquake alerting</span>
          </el-menu-item>
          <el-menu-item index="/about">
            <font-awesome-icon icon="fa-solid fa-people-roof" />
            <span slot="title"> About us</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="tabbar-mobile">
        <el-menu
          :default-active="activeIndex"
          :router="true"
          mode="horizontal"
        >
          <el-submenu index="">
            <template slot="title">Menu</template>
            <el-menu-item index="/">
              <font-awesome-icon icon="fa-solid fa-house" />
              <span slot="title"> Home</span>
            </el-menu-item>
            <el-menu-item index="/eq_perdict">
              <font-awesome-icon icon="fa-solid fa-chart-line" />
              <span slot="title"> Earthquake Alerting</span>
            </el-menu-item>
            <el-menu-item index="/about">
              <font-awesome-icon icon="fa-solid fa-people-roof" />
              <span slot="title"> About us</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import logoImg from "../assets/logo.png";

export default {
  name: "NavigateBar",
  data() {
    return {
      logoImg: logoImg,
      activeIndex: "/",
    };
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   console.log(key, keyPath);
    // },
  },
};
</script>

<style scoped>
#navigate {
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* border: 1px solid red; */
}
/* menu container */
.menu {
  width: 1320px;
  display: flex;
  justify-content: space-between;
  /* border: 1px solid green; */
}
/* logo */
.logo {
  margin-top: 5px;
  display: inline-block;
}
.logo-img {
  /* height: 32px; */
  height: 55px;
  width: 86px;
}
/* tabbar */
.tabbar {
  width: 450px;
  display: inline-block;
}
.menu-content {
  width: 1100px;
  border: none;
}
.el-menu.el-menu--horizontal {
  border: none;
  display: inline-block;
}
.el-menu--horizontal > .el-menu-item {
  font-size: 17px;
  border: none;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border: none;
}
/* 小菜单按钮 */
.el-menu--horizontal > .el-submenu {
  border: none;
}
.el-menu--horizontal > .el-submenu.is-active {
  border: none;
}

/* 判断屏幕宽度小于1320px后使用百分比 */
@media screen and (max-width: 1320px) {
  .menu {
    width: 90%;
  }
}
@media screen and (max-width: 600px) {
  .tabbar {
    display: none;
  }
}
@media screen and (min-width: 600px) {
  .tabbar-mobile {
    display: none;
  }
}
</style>